import React from 'react';

import { IInputProps } from './types';
import {
  InputContainer,
  InputControl,
  ComponentBefore,
  ComponentAfter,
} from './styled';

export const Input = React.forwardRef<HTMLInputElement, IInputProps>(
  (props, ref) => {
    return (
      <InputContainer data-testid={props.testId} {...props}>
        {props.componentBefore && (
          <ComponentBefore>{props.componentBefore}</ComponentBefore>
        )}
        <InputControl
          type="text"
          {...props}
          placeholder={props.placeholder}
          disabled={props.isDisabled}
          ref={ref}
        />
        {props.componentAfter && (
          <ComponentAfter>{props.componentAfter}</ComponentAfter>
        )}
      </InputContainer>
    );
  }
);

Input.displayName = 'UnfoldInput';
